<template>
  <div class="content">
    <div class="header">
      <div class="header-content">
        <div class="header-left">
          <img
            class="icon-logo"
            :src="oemInstitution ? oemInstitution.whAppLogo : projectConfig.logo"
            alt
          />创建店铺
        </div>
        <div class="header-right">
          <img :src="shop.shopLogo" alt="" />
          <span>{{ shop.linkTel }}</span>
          <el-button type="primary" size="mini" plain @click="loginOut">退出</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="box-card" v-for="item in typeList" :key="item.type">
        <div class="card-header">
          <img :src="item.bgImg" alt="" />
        </div>
        <div class="card-content">
          <p v-html="item.desc"></p>
          <el-button type="danger" plain @click="submitForm(item.type)">
            立即开店
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modifyShopInfo, getShopInfo, modifyShopType, loginOut } from "@/api/index.js";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      shopForm: {
        shopLogo: "",
        edcShopQRcode: "",
        shopName: "",
        shopNotice: "",
        shopTel: "",
        businessHours: "",
        startTime: "",
        endTime: "",
        cityName: "",
        shopAddress: "",
        edcfuncTags: "",
        takeoutStatus: true,
        tangStatus: true,
        shopCategoryIdTags: [1, 1],
        needChoosePeopleNum: 1,
        payMethod: 1,
        isAutoClearTable: 1,
        isAutoOrderNumber: 1,
        mealMethod: 1,
        sendScope: "",
        sendType: 1,
        distributionPrice: "",
        minDistributionPrice: "",
        toSendPrice: "",
        shopFaceImage: "",
        shopImages: "",
        bannerImage: "",
        indexBackgroundImage: "",
        isVerified: 0,
        nuonuoTaxNum: "",
        edcShopType: "",
      },
      typeList: [
        {
          bgImg: require("@/assets/img/login/bg-cy.png"),
          desc: "适用于<br/>需要搭建线上餐饮的商家",
          type: 1,
        },
        {
          bgImg: require("@/assets/img/login/bg-ls.png"),
          desc: "适用于需要<br/>搭建线零售超市的商家",
          type: 4,
        },
        {
          bgImg: require("@/assets/img/login/bg-ds.png"),
          desc: "适用于<br/>需要搭建线上电商的商家",
          type: 2,
        },
        {
          bgImg: require("@/assets/img/login/bg-jy.png"),
          desc: "适用于需<br/>要搭建线上加油站的商家",
          type: 5,
        },
        // {
        //   bgImg: require("@/assets/img/login/bg-ps.png"),
        //   desc: "适用于需要<br/>搭建线上生鲜配送的商家",
        //   type: 6,
        // },
        // {
        //   bgImg: require("@/assets/img/login/bg-jd.png"),
        //   desc: "适用于需要搭建线<br/>上客户住酒店的商家",
        //   type: 7,
        // },
        {
          bgImg: require("@/assets/img/login/bg-my.png"),
          desc: "适用于需要搭建线<br/>上预订美业各行业的商家",
          type: 8,
        },
        // {
        //   bgImg: require("@/assets/img/login/bg-jq.png"),
        //   desc: "适用于需要搭建<br/>线线上景区售票的商家",
        //   type: 9,
        // },
        // {
        //   bgImg: require("@/assets/img/login/bg-tg.png"),
        //   desc: "适用于需要搭<br/>建线上社区团购的商家",
        //   type: 10,
        // },
        // {
        //   bgImg: require("@/assets/img/login/bg-jf.png"),
        //   desc: "适用于需要搭建<br/>线上水电燃气缴费的商家",
        //   type: 11,
        // },
        // {
        //   bgImg: require("@/assets/img/login/bg-xy.png"),
        //   desc: "适用于需要<br/>搭建线上学校教育的商家",
        //   type: 12,
        // },
        // {
        //   bgImg: require("@/assets/img/login/bg-tc.png"),
        //   desc: "适用于需要搭建<br/>高效，智慧停车场的商家",
        //   type: 13,
        // },
      ],
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
      oemInstitution: (state) => state.oemInstitution,
      projectConfig: (state) => state.projectConfig,
    }),
  },
  created() {
    getShopInfo().then((res) => {
      if (res.code == 1) {
        this.updateShopInfo(res.data);
      }
    });
  },
  mounted() {},
  methods: {
    ...mapActions(["updateShopInfo"]),
    loginOut() {
      loginOut().then((res) => {
        if (res.code == 1) {
          localStorage.removeItem("sessionId");
          localStorage.removeItem("userId");
          localStorage.removeItem("userType");
          localStorage.removeItem("shopStoreId");
          this.clearShopInfo({});
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
    submitForm(type) {
      // let shopForm = JSON.parse(JSON.stringify(this.shopForm));
      // shopForm.businessHours = `${shopForm.startTime}-${shopForm.endTime}`;
      // shopForm.edcfuncTags = "";
      // shopForm.edcfuncTags = shopForm.takeoutStatus ? "1" : "";
      // shopForm.edcfuncTags +=
      //   shopForm.tangStatus && shopForm.takeoutStatus
      //     ? ",2"
      //     : shopForm.tangStatus
      //     ? "2"
      //     : "";
      // shopForm.shopCategoryId = shopForm.shopCategoryIdTags[1] || "";
      // shopForm.shopCategoryIdTags = shopForm.shopCategoryIdTags.join(",");
      // shopForm.cityName = JSON.stringify(shopForm.cityName);
      // shopForm.bannerImage = shopForm.bannerImage.length
      //   ? shopForm.bannerImage
      //   : "https://api.yichengshi.cn/images/edcmobile/default_banner.png";
      // shopForm.edcShopType = type;
      // modifyShopInfo(shopForm).then((res) => {
      //   if (res.code == 1) {
      //     getShopInfo().then((shopInfo) => {
      //       this.updateShopInfo(shopInfo.data);
      //       this.$router.push({
      //         path: "/",
      //       });
      //     });
      //   } else {
      //     if (res.code == 11) {
      //       this.$notify({
      //         title: "提示",
      //         message: "如需在线支付，请申请网付认证",
      //         type: "warning",
      //         duration: 2000,
      //       });
      //       return;
      //     }
      //     this.$notify({
      //       title: "提示",
      //       message: res.msg,
      //       type: "warning",
      //       duration: 2000,
      //     });
      //   }
      // });
      modifyShopType({
        edcShopType: type,
      }).then((res) => {
        if (res.code == 1) {
          getShopInfo().then((shopInfo) => {
            this.updateShopInfo(shopInfo.data);
            this.$router.push({
              path: "/",
            });
          });
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  position: relative;
  height: 100%;
  background: #fafafa;
  .header {
    color: #333333;
    background: #fff;
    padding: 18px 0;
    .header-content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      .header-left {
        font-size: 16px;
        .icon-logo {
          height: 82px;
          // width: 48px;
        }
        img {
          vertical-align: middle;
          padding-right: 10px;
          margin-right: 10px;
          border-right: 1px solid #ccc;
        }
      }
      .header-right {
        img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          vertical-align: middle;
        }
        span {
          font-size: 12px;
          margin: 0 5px;
          font-weight: bold;
        }
        vertical-align: middle;
      }
    }
  }
  .main {
    width: 1200px;
    margin: 0 auto;
    padding-top: 16px;
    display: flex;
    flex-wrap: wrap;
    .box-card {
      width: 180px;
      border-radius: 15px;
      border: 1px solid #e5e5e5;
      overflow: hidden;
      margin: 20px 20px 0 0;
      &:nth-of-type(6n) {
        margin-right: 0;
      }
      .card-header {
        img {
          width: 100%;
        }
      }
      .card-content {
        padding: 20px 0 40px 0;
        text-align: center;
        p {
          font-size: 13px;
          line-height: 26px;
          color: #888888;
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
